import PropTypes from 'prop-types';
import { useState } from 'react';
import { v4 } from 'uuid';

import { EBFD_HELP_URL } from 'xm-constants/urls';
import useHelpSearch from './useHelpSearch';

const EBFD_SEARCH_PREFIX = `${EBFD_HELP_URL}/search.htm`;

export default function EBFDHelpSearch({ iframeSrc, setHelpLocation }) {
  // Used to mimic the way xMatters Search hides the results (returns to previous view) on "clear":
  const [initialSrc, setInitialSrc] = useState(null);

  const { searchComponent } = useHelpSearch({
    onClear:
      !!initialSrc &&
      (() => {
        setHelpLocation(initialSrc);
        setInitialSrc(null);
      }),
    onKeyDown: e => {
      const query = e.target.value;
      if (e.key === 'Enter' && query?.length) {
        if (iframeSrc && !initialSrc?.startsWith(EBFD_SEARCH_PREFIX)) {
          setInitialSrc(iframeSrc);
        }
        const q = encodeURIComponent(query);
        setHelpLocation(`${EBFD_SEARCH_PREFIX}?q=${q}&forceReload=${v4()}`);
      }
    },
  });

  return searchComponent;
}
EBFDHelpSearch.displayName = 'EBFDHelpSearch';
EBFDHelpSearch.propTypes = {
  setHelpLocation: PropTypes.func.isRequired,
};
